
function About() {
    return (
      <div className="flex-grow">About</div>
    );
  }
  
  export default About;
  